import { Member } from "../../../shared/components/document-library/document-library-members";
import { EditDocumentSection, EditDocumentTreeLoader } from "../../../shared/components/document-tree/editable-document-tree/edit-document-tree";

export class WorkshopEntity {
    Id: string;
    Title: string;
    Description: string[];
    DateInformation: string;
    PlanningMembers: Member[];
    DocumentSections: EditDocumentSection[];
}

export class WorkshopSection {
    workshop: WorkshopEntity;
    dataTable: any; // Reference to the DataTable instance;
    visibleUserEmails: string = "";

    constructor(workshop: WorkshopEntity, targetFile: string = "", targetSearchBox: string = "") {
        this.workshop = workshop;
        let documentLibrary = new EditDocumentTreeLoader(this.workshop.DocumentSections, targetFile, targetSearchBox);

        if (this.workshop.PlanningMembers) {
            this.createMemberList();
        }
    }

    private createMemberList() {
        this.updateEmailList(this.workshop.PlanningMembers);
        this.initializeTable();
    }

    private createFilters(): void {
        // populate filters
        // add filter listeners
    }

    private resizeTable() {
        if (this.dataTable) {
            this.dataTable.columns.adjust().draw();
        }
    }

    private initializeTable(): void {
        // Check if there are any members to display
        if (!this.workshop.PlanningMembers || this.workshop.PlanningMembers.length === 0) {
            return;
        }

        // Initialize the DataTable with member data
        let tableId = `${this.workshop.Id}-member-list-table`
        this.dataTable = $(`#${tableId}`).DataTable({
            data: this.workshop.PlanningMembers,
            columns: [
                {
                    title: "Name",
                    className: "text-left font-size12",
                    data: (row: Member, type, val, meta) => {
                        if (type == "display") {
                            return this.getDisplayName(row);

                        }
                        else if (type == "sort") {
                            return row.LastName;

                        }
                        return row;
                    }
                },
                { data: "Role", title: "Role(s)", className: "text-left font-size12", render: (data) => { return data.join(", ") } },
                { data: "DisplayCenters", title: "Center(s)", className: "text-left font-size12", render: (data) => { return data.join(", ") } }
            ],
            paging: false,
            searching: false,
            info: false,
            scrollX: false,
            scrollY: '300px',
            scrollCollapse: true,
            dom: 'Bfrtip', // Required for buttons functionality
            buttons: [
                {
                    text: '<i class="fas fa-envelope"></i>',
                    titleAttr: 'Send Email',
                    action: () => this.handleEmailCopy() // Call shared method
                }

            ],
            order: []
        });

        $(`.${this.workshop.Id}-planning-tab`).on("shown.bs.tab", () => {
            setTimeout(() => this.resizeTable(), 100);
        })

    }

    private getDisplayName(row: Member): string {
        let display = `<span class="font-weight-500">${row.FirstName} ${row.LastName} <a href="mailto:${row.Email}" class="mail-icon pl-1"><i class="fa-solid fa-envelope fa-lg"></i></a></span>`
        return display;
    }

    private handleEmailCopy(): void {
        if (!this.visibleUserEmails.trim()) {
            return;
        }
        navigator.clipboard.writeText(this.visibleUserEmails).then(() => {
            $('#directory-email-modal').modal('show'); // Show modal
            $('#modal-email-list').text(this.visibleUserEmails); // Update modal content
        });
    }

    private updateEmailList(visibleMembers: Member[]): void {
        this.visibleUserEmails = visibleMembers.map(member => member.Email).join("; ");
    }
}